module.exports = __webpack_public_path__ + "img/blogger.886d4fc7.svg";